/**
 * Client-side mirror of the ingestion classifier's file→task routing
 * (customer-integrations packages/core/src/config/companyConfig.ts classify()),
 * which itself is the ported legacy getSyncType(). Powers the "where would this
 * file go?" tester on the settings page — keep the three implementations in
 * lockstep if the rules ever change.
 */

export const BUILTIN_KEYWORDS = {
	employee: ['employee', 'headcount', 'demographic'],
	job: ['requisition', 'job'],
	candidate: ['candidate'],
	bonus: ['bonuspaid', 'bonus'],
};

/** Task types in the order the classifier checks them — first match wins. */
export const TASK_ORDER = ['employee', 'job', 'candidate', 'bonus'];

/**
 * @returns {null | { taskType, matchedBy: 'keyword'|'includeKey', match }}
 */
export function classifyFilename(filename, sftpConfig) {
	const lower = String(filename || '').toLowerCase();
	const file = lower.split('/').pop() || lower;
	if (!file) return null;

	for (const taskType of TASK_ORDER) {
		const rule = sftpConfig?.[taskType];
		const keywords = BUILTIN_KEYWORDS[taskType];

		if (!rule) {
			const kw = keywords.find((k) => file.includes(k));
			if (kw) return { taskType, matchedBy: 'keyword', match: kw };
			continue;
		}

		const excluded = (rule.excludeKeys || []).find(
			(e) => file === e.toLowerCase() || lower.includes(e.toLowerCase())
		);
		if (excluded) continue;

		const kw = keywords.find((k) => file.includes(k));
		if (kw) return { taskType, matchedBy: 'keyword', match: kw };

		const inc = (rule.includeKeys || []).find((i) => lower.includes(i.toLowerCase()));
		if (inc) return { taskType, matchedBy: 'includeKey', match: inc };
	}

	return null;
}
